export var PLATFORM = 'web';
export var LOGIN = 'Login';
export var BOOK_APPOINTMENT = 'Book appointment';
export var RUN_PAYMENT_SUCCESS = 'Run payment';
export var CLOCK_IN = 'Clock in';
export var CLOCK_OUT = 'Clock out';
export var DOWNLOAD_CLIENTS_LIST = 'Download clients list';
export var DOWNLOAD_SERVICES_LIST = 'Download services list';
export var ADD_BARBER = 'Add barber';
export var DELETE_BARBER = 'Delete barber';
export var RUN_LEADERBOARD_REPORT = 'Run report: Leaderboard';
export var RUN_TGS_REPORT = 'Run report: Total Gross Sales';
export var RUN_SETTLEMENT_REPORT = 'Run report: Settlement';
export var RUN_SALES_BY_SERVICE_REPORT = 'Run report: Sales by service';
export var RUN_SALES_BY_PRODUCT_REPORT = 'Run report: Sales by product';
export var RUN_SALES_BY_BARBER_REPORT = 'Run report: Sales by barber';
export var RUN_BARBER_SALES_SUMMARY_REPORT = 'Run report: Barber sales summary';
export var RUN_ANALYTICS_REPORT = 'Run report: Analytics';
export var RUN_COMMISSION_PAYOUT_REPORT = 'Run report: Commission Payout';
export var RUN_APPOINTMENTS_REPORT = 'Run report: Appointments';
export var RUN_TIME_TRACKING_REPORT = 'Run report: Time Track';
export var RUN_DEPOSITS_REPORT = 'Run report: Deposits';
export var RUN_CUSTOM_REPORT = 'Run report: Custom Report';
